(function () {
  'use strict';

  angular.module('eclipseApp.myAccount').constant('timeZoneMappingConstants', {
      'AB': {
        stdTimeZone : 'MST',
        dstTimeZone : 'MDT',
        stdOffset   : '-7.0',
        dstOffset   : '-6.0'
      },
      'BC': {
        stdTimeZone : 'PST',
        dstTimeZone : 'PDT',
        stdOffset   : '-8.0',
        dstOffset   : '-7.0'
      },
      'MB': {
        stdTimeZone : 'CST',
        dstTimeZone : 'CDT',
        stdOffset   : '-6.0',
        dstOffset   : '-5.0'
      },
      'NB': {
        stdTimeZone : 'AST',
        dstTimeZone : 'ADT',
        stdOffset   : '-4.0',
        dstOffset   : '-3.0'
      },
      'NL': {
        stdTimeZone : 'NST',
        dstTimeZone : 'NDT',
        stdOffset   : '-3.5',
        dstOffset   : '-2.5'
      },
      'NS': {
        stdTimeZone : 'AST',
        dstTimeZone : 'ADT',
        stdOffset   : '-4.0',
        dstOffset   : '-3.0'
      },
      'NV': {
        stdTimeZone : 'EST',
        dstTimeZone : 'EDT',
        stdOffset   : '-5.0',
        dstOffset   : '-4.0'
      },
      'NT': {
        stdTimeZone : 'MST',
        dstTimeZone : 'MDT',
        stdOffset   : '-7.0',
        dstOffset   : '-6.0'
      },
      'ON': {
        stdTimeZone : 'EST',
        dstTimeZone : 'EDT',
        stdOffset   : '-5.0',
        dstOffset   : '-4.0'
      },
      'PE': {
        stdTimeZone : 'AST',
        dstTimeZone : 'ADT',
        stdOffset   : '-4.0',
        dstOffset   : '-3.0'
      },
      'QC': {
        stdTimeZone : 'EST',
        dstTimeZone : 'EDT',
        stdOffset   : '-5.0',
        dstOffset   : '-4.0'
      },
      'SK': {
        stdTimeZone : 'CST',
        dstTimeZone : 'CST',
        stdOffset   : '-6.0',
        dstOffset   : '-6.0'
      },
      'YT': {
        stdTimeZone : 'PST',
        dstTimeZone : 'PDT',
        stdOffset   : '-8.0',
        dstOffset   : '-7.0'
      }
    });
})();
